/**
 * Specifies the type of business event related to an algo certification report.
 * - Tag: 3078
 * - FIX Specification type: int
 * - Mapped type: number
 * @readonly
 * @public
 */
export const AlgoCertificateReportType = Object.freeze({
    CertificateInformation: 0,
    CertificateStateChanged: 1,
} as const);

export type AlgoCertificateReportType = (typeof AlgoCertificateReportType)[keyof typeof AlgoCertificateReportType];
